import React, { lazy, Suspense } from "react";
import { Router, Route, Switch, useLocation } from "react-router-dom";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./pages/home";
import FramerWebsite from "./components/FramerWebsite";
import { isWebsitePath } from "./constants/websiteRoutes";
// import Gallery from "./pages/Gallery";
import history from "./utils/history";
import { ToastContainer } from "react-toastify";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "./styles/globals.scss";
import "react-toastify/dist/ReactToastify.css";
import PageNotFound from "./pages/PageNotFound";
import AlbumLinkForm from "./components/AlbumLinkForm";
import DeptGetYourMomentsPage from "./pages/deptGetYourMoments";
import services, { isServicePath } from "./constants/services";
import Login from "./pages/login";
import DownloadReceipt from "./pages/DownloadReceipt";
import DolphinWorldReport from "./pages/DolphinWorldReport";
import * as Sentry from "@sentry/react";

const AdminPanel = lazy(() => import("./pages/AdminPanel"));

Sentry.init({
  dsn: "https://9fcf63c71a825e99af1a8df59f7d3774@o4506757435883520.ingest.sentry.io/4506757437063168",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

function AppBody() {
  const { pathname } = useLocation();
  const showWebsiteChrome =
    !isWebsitePath(pathname) && !isServicePath(pathname);

  return (
    <>
      {showWebsiteChrome && <Header />}
      <div className="main">
        <Switch>
          {/* In production Apache serves the five marketing routes below as
              static HTML from the Framer export, so these render only under
              `npm start` (and as a fallback if a page fails to deploy). */}
          <Route path="/" exact render={() => <Home />} />
          <Route
            path="/clients"
            exact
            render={() => <FramerWebsite page="/clients" />}
          />
          <Route
            path="/contact"
            exact
            render={() => <FramerWebsite page="/contact" />}
          />
          <Route
            path="/services"
            exact
            render={() => <FramerWebsite page="/services" />}
          />
          <Route
            path="/get-your-moments"
            exact
            render={() => <FramerWebsite page="/get-your-moments" />}
          />

          <Route
            path="/code/:code?"
            exact
            render={() => (
              <div
                style={{
                  height: "100vh",
                  background: "#1a1a1a",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AlbumLinkForm />
              </div>
            )}
          />

          <Route path="/login" exact render={() => <Login />} />

          <Route
            path="/download-receipt/:albumId"
            exact
            render={() => <DownloadReceipt />}
          />

          <Route
            path="/dolphin-world-report"
            exact
            render={() => <DolphinWorldReport />}
          />

          {/* <Route path="/gallery" exact render={() => <Gallery />} /> */}

          <Route path="/admin" render={() => <AdminPanel />} />
          <Route
            path="/reload"
            render={() => (
              <button
                onClick={() => {
                  window.location.reload(true);
                }}
              >
                reload
              </button>
            )}
          />

          {services.map((service) => (
            <Route
              path={`/${service.route}/:code?`}
              exact
              render={() => <DeptGetYourMomentsPage service={service} />}
              key={service.route}
            />
          ))}
          {services.map(
            (service) =>
              service.route1 && (
                <Route
                  path={`/${service.route1}/:code?`}
                  exact
                  render={() => <DeptGetYourMomentsPage service={service} />}
                  key={service.route1}
                />
              )
          )}

          <Route render={() => <PageNotFound />} />
        </Switch>
      </div>
      {showWebsiteChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        autoClose={10000}
        newestOnTop={false}
        closeOnClick
        hideProgressBar
        pauseOnHover
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <Suspense fallback={<div>Loading...</div>}>
        <Router history={history}>
          <AppBody />
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
